(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('AlertRules', AlertRules)
        .factory('WarningConstant', WarningConstant);

    AlertRules.$inject = ['$resource'];
    WarningConstant.$inject = ['$resource'];

    function AlertRules($resource) {
        var resourceUrl = 'api/warnings/:id';

        return $resource(resourceUrl, {}, {
            'query': {url: 'api/warnings-rules', method: 'GET'},
            'querySystem': {url: 'api/system-warnings', method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getWarningByUser': {
                url: 'api/warnings-user/:login',
                method: 'GET'
            },
            'getSystemWarningByUser': {
                url: 'api/system-warnings-user/:login',
                method: 'GET'
            },
            'update': {method: 'PUT'},
            'insertAlerts': {
                method: 'PUT',
                url: 'api/warnings-alerts'
            },
            'deleteAlerts': {
                method: 'PUT',
                url: 'api/warnings-delete-alerts'
            },
            'notifications': {
                method: 'GET',
                url: 'api/warnings/notification-status/:id/:type'
            },
            'toggleChannel': {
                method: 'PUT',
                url: 'api/warnings-toggle-channel'
            },
            'domainToggleChannel': {
                method: 'GET',
                url: 'api/my-channel-user-toggle/:login/:type/:status'
            },
            'wipAlerts': {
                method: 'GET',
                url: 'api/warnings-wip/:warning/:wip/:objectUniqueCode'
            },
            'requestSendEmail': {url: 'api/warnings/sendEmail', method: 'POST'}
        });
    }

    function WarningConstant($resource) {
        var resourceUrl = 'api/warnings/status';

        return $resource(resourceUrl, {}, {
            'update': {method: 'PUT'}
        });
    }
})();
